import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';

import { InputBackOffice } from '../../components/common/InputBackoffice';
import { Label } from '../../styles/stylesStyled';
import { useState } from 'react';
import { Button, ErrorToast } from '../../components';
import { useDispatch } from 'react-redux';
import { createWebinarMenagement } from '../../slices/webinars-slice';
import moment from 'moment';

const CreateWebinar = ({ setIsSideModalOpen }: { setIsSideModalOpen: any }) => {
  const dispatch = useDispatch();
  const { loading } = useAppSelector((state) => state.webinars);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [ticketPrice, setTicketPrice] = useState('');
  const [numberOfTickets, setNumberOfTickets] = useState('');
  const [date, setDate] = useState('');

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <Label>Name</Label>
          <InputBackOffice
            id='name'
            type='text'
            placeholder={'Enter name'}
            name='name'
            value={name}
            onChange={(e: string) => setName(e)}
          />

          <Label>Ticket Price</Label>
          <InputBackOffice
            id='price'
            type='number'
            placeholder={'Enter price'}
            name='price'
            value={ticketPrice}
            onChange={(e: string) => setTicketPrice(e)}
          />
          <Label>Number of tickets</Label>
          <InputBackOffice
            id='numOfTickets'
            type='number'
            placeholder={'Enter number of tickets'}
            name='numOfTickets'
            value={numberOfTickets}
            onChange={(e: string) => setNumberOfTickets(e)}
          />
          <Label>Description</Label>
          <InputBackOffice
            id='description'
            type='textarea'
            placeholder={'Enter description'}
            name='description'
            value={description}
            onChange={(e: string) => setDescription(e)}
          />
          <Flatpickr
            className='form-control'
            id='datepicker-publish-input'
            placeholder='Select a date'
            options={{
              altFormat: 'd M Y, H:i',
              dateFormat: 'Y-m-d H:i',
              enableTime: true,
              minDate: 'today'
            }}
            value={date}
            onChange={([selectedDate]) => {
              setDate(moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss'));
            }}
          />
          <Button
            mt='20'
            onClick={() => {
              if (!name) {
                ErrorToast('Please enter a name');
              } else if (!ticketPrice) {
                ErrorToast('Please enter the ticket price');
              } else if (!numberOfTickets) {
                ErrorToast('Please enter the number of tickets');
              } else if (!description) {
                ErrorToast('Please enter a description');
              } else if (!date) {
                ErrorToast('Please select a date');
              } else {
                dispatch(
                  createWebinarMenagement({
                    name,
                    description,
                    ticketPrice,
                    numberOfTickets,
                    date,
                    setIsSideModalOpen
                  })
                );
              }
            }}>
            Create webinar
          </Button>
        </div>
      )}
    </>
  );
};

export default CreateWebinar;
